<div class="container" [class.alert-popup--dark]="data.darkTheme">
  <div class="card">
    <div class="task-head">
      <h4>{{ getTitle() }}</h4>
    </div>

    <p>{{ data.message }}</p>
  </div>

  <div class="btns">
    <button 
      *ngFor="let button of data.buttons"
      mat-flat-button
      [ngClass]="button.primary ? 'alert-btn--primary' : 'alert-btn--secondary'"
      (click)="onButtonClick(button)"
    >
      {{ button.text }}
    </button>
  </div>
</div>
